import { YOO_FINDS_CDN } from "@/common";

const baseH5Url = `${YOO_FINDS_CDN}/h5/spring`;
const basePcUrl = `${YOO_FINDS_CDN}/pc/spring`;

export const SPRING_SPRING_PICKS = `${baseH5Url}/spring-picks.png`;
export const SPRING_NEW_PICKS = `${baseH5Url}/new-picks.png`;
export const SPRING_WOMEN_SWEAR = `${baseH5Url}/women-swear.png`;
export const SPRING_BEAUTY = `${baseH5Url}/beauty.png`;
export const SPRING_PHONES = `${baseH5Url}/phones.png`;
export const SPRING_HOME = `${baseH5Url}/home.png`;

export const SPRING_RANK_BANNER = `${basePcUrl}/spring-banner.png`;
export const SPRING_RANK_NO_DATA = `${basePcUrl}/no-data.png`;
export const SPRING_RANK_Time_BG = `${basePcUrl}/time-bg-v1.png`;

export const SPRING_ICON = `${basePcUrl}/spring-icon.png`;
